<div class="main row">
  <ds-confirmation [confirmationData]="confirmationData">
    <ds-confirmation-card-area>
      <div class="row">
        <!-- autopay auth component -->
        @if (showAutopayCard) {
          <ds-autopay-card
            class="column pad-bottom twelve program-tiles"
            [ngClass]="{
              'md-pad-right md-six': showPaperlessCard
            }"
            [confirmationDetails]="((confirmationData?.details)[0]?.tableRows)[0]"
            [errorList]="autopayErrorList$ | async"
            [paymentTerm]="paymentTerm"
            (customizeEvent)="autopayCustomize($event)"
            (signupEvent)="autopaySignup($event)"
          >
          </ds-autopay-card>
        }

        <!-- Ez button component -->
        @if (showPaperlessCard && (isEligibleToGoPaperless$ | async) && !isAdminApp) {
          <amfam-set-billing-and-policy-preferences
            class="column pad-bottom twelve program-tiles"
            [ngClass]="{
              'md-six': showAutopayCard
            }"
          >
          </amfam-set-billing-and-policy-preferences>
        }
      </div>
    </ds-confirmation-card-area>

    <ds-confirmation-link-area>
      <div>
        @if (
          isFuturePaymentSupported &&
          ((hasAnyAdvancedPolicyForBillAccount$ | async) || !matchingbillaccount?.associated) &&
          !deleteScheduled &&
          billingConfirmationData?.billAccounts?.length === 1
        ) {
          <a
            class="font-weight-semibold linkArea"
            href="javascript:void(0);"
            dsContent
            [contentPath]="'billing.viewFuturePayments'"
            [dsAnalyticsClick]="clickFuturePaymentsLink.link"
            [dsRouterLink]="[billingDetailPath]"
            [queryParams]="{ openAccordion: 'scheduleAccordion' }"
            [options]="{ policyNumber: policyNumber }"
          ></a>
        }
        <a
          class="font-weight-semibold linkArea"
          href="javascript:void(0);"
          dsContent
          [contentPath]="'billing.backToBillingAndPayments'"
          [dsRouterLink]="[cancelPath]"
        >
        </a>
      </div>
    </ds-confirmation-link-area>
  </ds-confirmation>
  <br />
</div>
